var App = App || {};

App.SectionTabs = (function ($) {
    'use strict';

    function syncAccordionPaneState(section) {
        section.find('.section-tabs-mobile-accordion .accordion-collapse.tab-pane').each(function () {
            const pane = $(this);
            const isShown = pane.hasClass('show');

            pane.toggleClass('active', isShown);
        });
    }

    function updateAccordionAria(section) {
        section.find('.section-tabs-mobile-accordion .accordion-button').each(function () {
            const button = $(this);
            const heading = $.trim(button.text());
            const isExpanded = button.attr('aria-expanded') === 'true';

            button.attr('aria-label', (isExpanded ? 'Collapse ' : 'Expand ') + heading + ' panel');
        });
    }

    function Init(selector) {
        if (!selector.length) {
            return;
        }

        selector.each(function () {
            const section = $(this);
            const mobileAccordion = section.find('.section-tabs-mobile-accordion');

            if (!mobileAccordion.length) {
                return;
            }

            mobileAccordion.on('shown.bs.collapse hidden.bs.collapse', function () {
                syncAccordionPaneState(section);
                updateAccordionAria(section);
            });

            syncAccordionPaneState(section);
            updateAccordionAria(section);
        });
    }

    return {
        Init: Init
    };

})(jQuery);
